<mat-card>
    <mat-card-content>
        <div class="state">
            <span>{{ dockingContext?.stateName }}</span>
        </div>

        <div class="conmon-monitoring-status" *ngIf="dockingContext.conMonActive">
            <span
                *ngIf="(conMonRequired(dockingContext) && userIsMonitoringDocking) || (isFopMode && dockingContext.conMonActive)">
                <mat-icon (click)="openMonitoringMopOperatorsDialog()" class="on">visibility</mat-icon>
            </span>
            <span *ngIf="conMonRequired(dockingContext) && !userIsMonitoringDocking">
                <mat-icon (click)="openMonitoringMopOperatorsDialog()" class="off">visibility_off</mat-icon>
            </span>
        </div>

        <div class="commands-wrapper">
            <div class="messages" *ngIf="dockingContext?.messages?.length">
                <div class="span-container" *ngFor="let message of dockingContext?.messages">
                    <span class="message">
                        {{ message }}
                    </span>
                </div>
            </div>

            <div *ngIf="commandsShouldBeVisible()">
                <div class="commands" *ngIf="dockingContext?.criticalCommands?.length">
                    <ng-container *ngFor="let criticalCommand of dockingContext?.criticalCommands">
                        <div class="command" *ngIf="commandAllowedOnDevice(criticalCommand)">
                            <button
                                mat-raised-button
                                class="critical-command"
                                data-cy="docking-critical-command"
                                [disabled]="buttonsDisabled"
                                (click)="triggerDockingCommand(criticalCommand)"
                            >
                                {{ criticalCommand.text }}
                            </button>
                        </div>
                    </ng-container>
                </div>

                <div class="commands" *ngIf="dockingContext?.commands?.length">
                    <ng-container *ngFor="let command of dockingContext?.commands">
                        <div class="command" *ngIf="commandAllowedOnDevice(command)">
                            <button
                                mat-raised-button
                                color="primary"
                                data-cy="docking-command"
                                [disabled]="buttonsDisabled"
                                (click)="triggerDockingCommand(command)"
                            >
                                {{ command.text }}
                            </button>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="commands">
            <div
                class="command"
                *ngIf="
                conMonRequired(dockingContext) &&
                !userIsMonitoringDocking &&
                !dialogOpen
            "
            >
                <button mat-raised-button color="primary" class="command" (click)="openConMonDialog()">
                    Monitor docking
                </button>
            </div>
        </div>

        <div class="commands back" *ngIf="dockingContext?.inSelectionMenu">
            <button
                mat-raised-button
                color="primary"
                class="command"
                data-cy="back-command"
                [disabled]="buttonsDisabled"
                (click)="goBack()"
            >
                Back
            </button>
        </div>
    </mat-card-content>
</mat-card>
